import { render, staticRenderFns } from "./SystemView.vue?vue&type=template&id=6f9a332c&scoped=true"
import script from "./SystemView.vue?vue&type=script&lang=ts"
export * from "./SystemView.vue?vue&type=script&lang=ts"
import style0 from "./SystemView.vue?vue&type=style&index=0&id=6f9a332c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a332c",
  null
  
)

export default component.exports